
























































































import { defineComponent, reactive, toRefs, onMounted, watch, ref } from '@vue/composition-api'
import * as Common from "../../commons/common"
import http from "../../plugins/http"
import AlertArea from "../../components/AlertArea.vue"
import MasterMainteTab from "../../components/MasterMainteTab.vue"
import { BTable } from 'bootstrap-vue'
import { SearchCondition, BaseSheet } from "../../modules/teacher/ProgressSheetList"
import { SearchCondition as ProgressStudentListCondition } from "../../modules/teacher/ProgressStudentList"

export interface Data {
  condition: SearchCondition
  baseSheets: BaseSheet[]
  sortedBaseSheets: BaseSheet[]
  perPage: number
  totalCount: number
  isShowPagination: boolean
  fields: any[]
  errors: string[]
  comboboxCourse: any[]
  comboboxCampus: any[]
  comboboxClassification: any[]
  nendos: number[]
}

export default defineComponent({
  components: {
    "master-mainte-tab": MasterMainteTab,
    "alert-area": AlertArea,
  },
  setup(props, context){

    const tableRef = ref<InstanceType<typeof BTable>>();

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      condition: new SearchCondition(),
      baseSheets: new Array<BaseSheet>(),
      sortedBaseSheets: new Array<BaseSheet>(),
      perPage: 100,
      totalCount: 0,
      isShowPagination: false,
      fields: [
        {key: "sheet_code", label: "レポートID", sortable: true, class: 'text-center b-table-th-td'},
        {key: "nendo", label: "年度", sortable: true, class: 'text-center b-table-th-td'},
        {key: "subject_code", label: "科目", sortable: true, class: 'text-center b-table-th-td'},
        {key: "report_no", label: "レポートNo", sortable: true, class: 'text-center b-table-th-td'},
        {key: "sheet_name", label: "レポート名", sortable: true, class: 'text-center b-table-th-td'},
        {key: "publish_at", label: "公開日", sortable: true, class: 'text-center b-table-th-td'},
        {key: "std_deadline_at", label: "標準締切", sortable: true, class: 'text-center b-table-th-td'},
        {key: "final_deadline_at", label: "最終締切", sortable: true, class: 'text-center b-table-th-td'},
        {key: "student_count", label: "受験人数", sortable: true, class: 'text-center b-table-th-td'},
        {key: "submitted_count", label: "提出数", sortable: true, class: 'text-center b-table-th-td'},
        {key: "submitted_percent", label: "提出率", sortable: true, class: 'text-center b-table-th-td'},
        {key: "not_submitted_count", label: "未提出数", sortable: true, class: 'text-center b-table-th-td'},
        {key: "detail", label: "未提出者", sortable: false, class: 'text-center b-table-th-td'},
      ],
      errors: [],
      comboboxCourse: [],
      comboboxCampus: [],
      comboboxClassification: [],
      nendos: [],
    });

    /******************************
     * 検索ボタンクリック
     ******************************/

    const searchButtonClick = async () => {
      state.condition.page = 1;
      await search();
    }

    /******************************
     * ページング
     ******************************/

    const changePage = (page: number) => {
      state.condition.page = page;
      search();
    };

    /******************************
     * ソート
     ******************************/

    const onSortChanged = (sortInfo: { sortBy: string; sortDesc: boolean }) => {
      state.sortedBaseSheets = [...state.baseSheets].sort((a: any, b: any) => {
        const key = sortInfo.sortBy;
        const order = sortInfo.sortDesc ? -1 : 1;
        return a[key] < b[key] ? -1 * order : 1 * order;
      });
    };

    /******************************
     * 検索API
     ******************************/

    const search = async () => {
      
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.errors = [];
      await http.get(`/api/teacher/progress_sheet_list?${Common.BuildQuery(state.condition, 'search_condition')}`).then(response => {
        state.baseSheets = response.data.base_sheets.map((x: any) => new BaseSheet(x));
        state.sortedBaseSheets = state.baseSheets;
        state.totalCount = response.data.base_sheets == 0 ? 0 : response.data.base_sheets[0].full_count;
        state.comboboxCourse = Common.createComboboxOptions(response.data.result_vieable_courses, "course_code", "name", true);
        state.comboboxCampus = Common.createComboboxOptions(response.data.result_vieable_campuses, "campus_code", "name", true);
        state.comboboxClassification = Common.createComboboxOptions(response.data.result_vieable_classifications, "class_code", "name", true);
        context.root.$store.commit("setProgressSheetListCondition", state.condition);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 検索条件クリア
     ******************************/

    const clearCondition = () => {
      state.condition = new SearchCondition();
      state.condition.nendo = Common.getNendo();
    };

    /******************************
     * 未提出者画面へ
     ******************************/

    const toProgressStudentList = (base_sheet_id: number) => {
      context.root.$store.commit("setProgressStudentListCondition", new ProgressStudentListCondition());
      context.root.$router.push(`/teacher_site/progress_student_list/${base_sheet_id}`).catch(err => {});
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {

      state.condition = context.root.$store.state.progressSheetListCondition;

      // 本日日付から年度を取得
      const nendo = Common.getNendo();

      // 年度プルダウンのoption設定
      for(let i = -3; i <= 2; i++){
        state.nendos.push(nendo + i);
      }

      if(!state.condition.nendo){
        // 検索条件.年度未設定の場合、今年度を設定
        state.condition.nendo = nendo;
      }

      await search();
      state.isShowPagination = true;
    });

    return {
      ...toRefs(state),
      tableRef,
      search,
      clearCondition,
      changePage,
      toProgressStudentList,
      searchButtonClick,
      onSortChanged,
    };
  }
});

